<!-- NOTIFICATION -->
@if (errorCode != 0) {
  <notification [timeout]="10000" severity="error" [message]="errorMessage" (hideNotification)="onClose()"></notification>
}
@if (firstLogin) {
  <notification severity="info" message="First login - You must change your password"></notification>
}

<div id="login-page">
	<div id="login-form-container">
		<div id="logo-container">
			<img src="../../../css/images/smoothiz.png" title="SMOOTHIZ by Xpertiz" />
		</div>

		<form id="login-form" [formGroup]="userForm">
			<div class="form-group" [formGroup]="userForm">
				<input type="text" placeholder="Username" class="form-control" required formControlName="userName" name="userName" ngControl="userName" autocomplete="off" />
			</div>
			<div class="form-group" style="margin-top: 0" [formGroup]="userForm" [ngClass]="{ 'has-error': firstLogin && userPassword != userConfirmPassword, 'is-empty': userPassword === '' }">
				<input type="password" placeholder="Password" class="form-control" required formControlName="userPassword" name="userPassword"
					ngControl="userPassword" autocomplete="off" />
        @if (firstLogin && userPassword != userConfirmPassword) {
          <span id="help-userPassword" class="help-block">Password does not match the confirmation</span>
        }
      </div>
      @if (firstLogin) {
        <div class="form-group" style="margin-top: 0" [formGroup]="userForm" [ngClass]="{ 'is-empty': userConfirmPassword === '' }">
          <input type="password" placeholder="Confirm password" class="form-control" required formControlName="userConfirmPassword" name="userConfirmPassword"
                 ngControl="userConfirmPassword" autocomplete="off" />
        </div>
      }
      @if (!firstLogin) {
        <div class="row">
          <div class="col-xs-12"><button (click)="getSalt()" class="btn btn-raised btn-block">Log in</button></div>
        </div>
      }
      @if (firstLogin) {
        <div class="row">
          <div class="col-xs-12"><button (click)="changePassword()" class="btn btn-raised btn-block">Change password</button></div>
        </div>
      }
		</form>
	</div>

	<div id="smoothiz-version">Front: {{version}}<br/>Back: {{backEndVersion()}}</div>
</div>
